import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class NotificationPreferencesService {
    private readonly TIME_DISPLAY_KEY = 'notification_time_display_preference';

    getTimeDisplayPreference(): boolean {
        const preference = localStorage.getItem(this.TIME_DISPLAY_KEY);
        return preference === 'exact';
    }

    setTimeDisplayPreference(showExactTime: boolean): void {
        localStorage.setItem(this.TIME_DISPLAY_KEY, showExactTime ? 'exact' : 'relative');
    }
}
